<template>
  <div class="award-show">
    <div class="award-title">
      <div class="award-bg-mask">
        <span>{{ data.title }}</span>
      </div>
    </div>
    <template v-if="data.smallFont">
      <div class="award-name" style="font-size: 12px">
        {{ data.name }}
      </div>
    </template>
    <template v-else>
      <div class="award-name">{{ data.name }}</div>
    </template>
    <div
      class="award-name"
      v-if="data.name1"
      style="top: 76px; font-size: 12px"
    >
      {{ data.name1 }}
    </div>
    <img class="award-img" alt="award-img" :src="data.img" />
  </div>
</template>

<script>
export default {
  name: 'AwardShow',
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.award-show {
  width: 100%;
  height: 100%;
  background: #fff;
  position: relative;
  padding: 0 12px;
  border-radius: 0 0 23px 23px;
  .award-title {
    width: 108%;
    height: 36px;
    line-height: 36px;
    background-color: #fff;
    border-radius: 0 100px 100px 0;
    position: absolute;
    left: -14px;
    top: -2px;
    border-radius: 0 100px 100px 0;
    font-weight: bold;
    color: #4686f2;
    font-family: Alibaba-PuHuiTi-B;
    text-align: center;
    font-size: 18px;
    padding: 1px;
    background-image: linear-gradient(to right, #3060ff, #0ff4f1);
    .award-bg-mask {
      background-color: #fff;
      height: 33px;
      border-radius: 0 100px 100px 0;
    }
    span {
      background-image: linear-gradient(90deg, #f14c5d, #8647dd);
      -webkit-background-clip: text;
      color: transparent;
    }
    &::after {
      content: '';
      display: inline-block;
      border-top: solid 4px #e5ccff;
      border-right: solid 6px #e5ccff;
      position: absolute;
      top: 35px;
      left: 0;
      border-bottom: solid 4px transparent;
      border-left: solid 6px transparent;
    }
  }
  .award-name {
    font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
      Verdana, 'PingFang SC';
    font-size: 16px;
    color: #333;
    line-height: 18px;
    position: absolute;
    left: 50%;
    top: 52px;
    transform: translateX(-50%);
    text-align: center;
    width: 90%;
    font-weight: 500;
  }
  .award-img {
    // width: 160px;
    height: 138px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/competeAward/awardShow.vue